import { configureStore } from '@reduxjs/toolkit';
import pdfEditorReducer from './slices/pdfEditorSlice';

export const store = configureStore({
  reducer: {
    pdfEditor: pdfEditorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['pdfEditor/setReportData', 'pdfEditor/setAvailableAssets', 'pdfEditor/createDocument', 'pdfEditor/loadDocument'],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.createdAt', 'payload.updatedAt', 'payload.pages'],
        // Ignore these paths in the state
        ignoredPaths: [
          'pdfEditor.reportData.createdAt', 
          'pdfEditor.reportData.updatedAt', 
          'pdfEditor.currentDocument.createdAt', 
          'pdfEditor.currentDocument.updatedAt',
          'pdfEditor.history'
        ],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
